import { render, staticRenderFns } from "./WeightSubmissionAlert.vue?vue&type=template&id=39f51920&"
import script from "./WeightSubmissionAlert.vue?vue&type=script&lang=js&"
export * from "./WeightSubmissionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports